export const DEFAULT_SERVER_ERROR = 'Ошибка сервера. Попробуйте еще раз или зайдите позже';
